export default __webpack_public_path__ + "static/media/quiz.5f924652.png";